
<div class="grid" *ngIf="!loading">
  <div class="col-12 md:col-4" *ngFor="let location of locations">
    <a [routerLink]="location.disabled ? null : [location.route]"
      [state]="{ facilityCode: getFacilityCode(location.name) }"
      (click)="$event.preventDefault(); !location.disabled && navigate(location)"
      style="text-decoration: none; color: inherit; cursor: pointer;">
      <p-card class="card-head" [ngClass]="{'disabled-card': location.disabled}">
        <ng-template pTemplate="title">
          <h3 class="card_title">{{location.name}}</h3>
        </ng-template>
        <ng-template pTemplate="content">
          <div class="card-content">
            <img [src]="location.image" class=" location-img">
            <div class="details-container">              <div *ngFor="let detail of location.tlrs" class="details-row">
                <div class="detail-content">
                  <div class="title-line">
                    <span class="title">{{detail.name}}</span>
                    <span class="count" [ngClass]="{
                      'red-value': (detail.name.includes('Beyond Due Date') || detail.name.includes('Orphan TLRs')) && !detail.name.startsWith('SL'),
                      'blue-value': detail.name.includes('Open TLRs(TLR,Hot,Tap,Stopple)') && !detail.name.startsWith('SL')
                    }">{{detail.value}}</span>
                  </div>
                  <div *ngIf="detail.description" class="description-line">
                    {{detail.description}}
                  </div>
                </div>

                <!-- <ul>
                <li *ngFor="let detail of location.details">
                  {{detail.title}}:{{detail.count}}
                  </li>
                </ul> -->
              </div>
            </div>
          </div>
        </ng-template>
      </p-card>
    </a>
  </div>
</div>